import * as Koa from 'koa'

export function getClientIP(ctx: Koa.Context) {
  let ip = ctx.headers['ali-cdn-real-ip'] || ctx.headers['x-real-ip']
  if (ip) {
    return ip
  }

  ip = ctx.headers['x-forwarded-for']
  if (ip) {
    if (ip.indexOf(',') === -1) {
      return ip
    }
    const ips = (ip as string).split(/,\s*/)
    const rIsLocal = /^(10|192\.168)\./
    if (ips.length > 1 && rIsLocal.test(ips[0]) && !rIsLocal.test(ips[1])) {
      return ips[1]
    }
    return ips[0]
  }

  if (isObject(ctx) && isObject(ctx.req)) {
    // koa
    ip = ctx.req && ctx.req.socket.remoteAddress
  } else {
    // express
    ip = ctx.socket.remoteAddress
  }

  if (!ip) {
    return '255.255.255.255'
  }
  if (ip === '::1') {
    return '127.0.0.1'
  }

  return ip.replace(/^:.*:/, '')
}

export function isObject(value: any) {
  const type = typeof value
  return value != null && (type === 'object' || type === 'function')
}

const SPIDER_UA = [
  'Baiduspider-image',
  'Baiduspider-video',
  'Baiduspider-news',
  'Baiduspider-image',
  'Baiduspider-render',
  'Baiduspider',
  'Googlebot-Image',
  'Googlebot',
  '360Spider',
  'Sogou Pic Spider',
  'Sogou News Spider',
  'Sogou Video Spider',
  'Sogou web spider',
  'SogouSpider',
  'YisouSpider',
  'bingbot',
  'msnbot',
  'msnbot-media',
  'Yahoo! Slurp China',
  'Yahoo!',
  'Bytespider',
]

export const getSpider = (ua: string) => {
  return SPIDER_UA.find((spiderKey) => {
    if (-1 !== (ua || '').indexOf(spiderKey)) {
      return true
    }
    return false
  })
}
